<template>
  <v-dialog v-if="dialog" v-model="dialog" width="1000px" @click:outside="close" scrollable>
    <v-card height="600px">
      <v-card-title>
        <span class="headline">Modifier Espèce</span>
      </v-card-title>
      <v-card-subtitle
        ><p style="word-break: keep-all">
          <span style="color: #757575"
            >{{ editedItem.nom_famille }}
            >
            {{ editedItem.nom_genre }}
            >
          </span>
          {{ editedItem.espece }}
        </p></v-card-subtitle
      >

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                dense
                disabled
                v-model="editedItem.id_pollen"
                label="ID Pollen"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4"
              ><p class="text-h6">Taxonomie:</p></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                dense
                outlined
                :items="getFamille"
                item-text="nom_famille"
                item-value="id_famille"
                label="Famille"
                v-model="editedItem.id_famille"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-autocomplete
                dense
                outlined
                :disabled="editedItem.id_famille === ''"
                :items="
                  getGenre.filter((g) => g.id_famille === editedItem.id_famille)
                "
                item-text="nom_genre"
                item-value="id_genre"
                label="Genre"
                v-model="editedItem.id_genre"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                dense
                outlined
                v-model="editedItem.espece"
                label="Nom Espece"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                dense
                outlined
                v-model="editedItem.nom_revise"
                label="Nom Espece (taxonomie revisée)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4"
              ><p class="text-h6">Général:</p></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="editedItem.herbier"
                label="Herbier"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="editedItem.lame"
                label="LAME"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="editedItem.labo"
                label="Laboratoire"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4"
              ><p class="text-h6">Dimensions:</p></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="editedItem.dimensionp"
                label="Dimension P"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                outlined
                dense
                v-model="editedItem.dimensione"
                label="Dimension E"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="4"
              ><p class="text-h6">Biblio et remarques:</p></v-col
            >
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                v-model="editedItem.biblio"
                filled
                label="Biblio"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                filled
                v-model="editedItem.remarques"
                label="Remarques"
              ></v-textarea>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                v-model="editedItem.pollenassocies"
                filled
                label="Pollen associes"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#2B2118" text @click="close"> Annuler </v-btn>
        <v-btn
          :disabled="
            editedItem.espece === '' ||
            editedItem.id_genre === '' ||
            editedItem.id_famille === ''
          "
          color="#2B2118"
          dark
          @click="save"
        >
          Sauvegarder
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      defaultItem: {
        id_pollen: "",
        id_famille: "",
        id_genre: "",
        espece: "",
        lame: "",
        labo: "",
        herbier: "",
        dimensionp: "",
        dimensione: "",
        biblio: "",
        remarques: "",
        pollenassocies: "",
        nom_revise: "",
      },
    };
  },
  props: ["currentitem", "dialog"],
  computed: {
    ...mapGetters(["getFamille", "getGenre"]),
    editedItem: {
      get() {
        return this.currentitem;
      },
      set(value) {
        this.$emit("update:currentitem", value);
      },
    },
  },
  methods: {
    ...mapActions(["updatePollen"]),
    close() {
      this.$emit("update:currentitem", this.defaultItem);
      this.$emit("update:dialog", false);
    },
    save() {
      this.updatePollen(this.editedItem);
      this.close();
    },
  },
};
</script>

<style>
</style>